<ng-template #buttonContent>
  <div class="action-button__content">
    <span class="action-button__avatar"><ng-content select="[actionButtonAvatar]" /></span>

    @if (castedIcon()) {
      <i class="aw-2-icn action-button__icon" aria-hidden="true" [awIcon]="castedIcon()">{{ castedIcon() }}</i>
    }

    @if (image()) {
      <img
        class="action-button__image"
        alt=""
        [class.action-button__image--round]="roundImage()"
        [width]="imageSize()"
        [height]="imageSize()"
        [ngSrc]="image()"
      />
    }

    @if (text()) {
      <span class="action-button__text">{{ text() }}</span>
    }

    @if (showCounter()) {
      <aw-badge
        class="action-button__counter"
        [label]="counter()"
        [size]="badgeSize()"
        [type]="BadgeType.border"
        [color]="badgeColor()"
      />
    }
  </div>

  @if (showRemoveButton()) {
    <aw-dismiss-button
      class="action-button__remove"
      [size]="removeButtonSize()"
      [clear]="true"
      [tooltip]="removeTooltip()"
      (onClick)="onRemoveClick($event)"
      (mouseenter)="removeButtonHovered.set(true)"
      (mouseleave)="removeButtonHovered.set(false)"
    />
  }
</ng-template>

@if (withDropdown()) {
  <div class="action-button-wrapper">
    <article
      role="button"
      [attr.tabindex]="0"
      [attr.aria-label]="ariaLabel()"
      [attr.aria-disabled]="disabled()"
      [attr.aria-pressed]="selected()"
      [attr.aria-expanded]="ariaExpanded()"
      [attr.aria-controls]="ariaControls()"
      [class]="buttonClasses()"
      [awTooltip]="tooltip()"
      [actionTooltip]="true"
      [fromTop]="tooltipFromTop()"
      [suppress]="removeButtonHovered()"
      (click)="onButtonClick($event)"
      (keydown.enter)="onKeydown($event)"
      (keydown.space)="onKeydown($event)"
    >
      <ng-container [ngTemplateOutlet]="buttonContent" />
    </article>
    <aw-action-dropdown-button
      [type]="type()"
      [size]="dropdownSize()"
      [selected]="selected()"
      [disabled]="disabled()"
      [tooltip]="dropdownTooltip()"
      [tooltipFromTop]="tooltipFromTop()"
      (onClick)="handleDropdownClick($event)"
    />
  </div>
} @else {
  <article
    role="button"
    [attr.tabindex]="0"
    [attr.aria-label]="ariaLabel()"
    [attr.aria-disabled]="disabled()"
    [attr.aria-pressed]="selected()"
    [attr.aria-expanded]="ariaExpanded()"
    [attr.aria-controls]="ariaControls()"
    [class]="buttonClasses()"
    [awTooltip]="tooltip()"
    [actionTooltip]="true"
    [fromTop]="tooltipFromTop()"
    [suppress]="removeButtonHovered()"
    (click)="onButtonClick($event)"
    (keydown.enter)="onButtonClick($event)"
    (keydown.space)="onButtonClick($event)"
  >
    <ng-container [ngTemplateOutlet]="buttonContent" />
  </article>
}
